import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebDevCommerceLogo,
  WebDevWebsitesLogo,
  WebDevContentLogo,
  WebDevWebAppLogo,
} from "../../../app-constants";

import { Link } from "gatsby";

const StackItem = [
  {
    icon: WebDevWebsitesLogo,
    title: "Websites",
    description:
      "Create dynamic websites with responsive design and scalable architectures. Offer easy navigation with zero latency and generate leads.",
  },
  {
    icon: WebDevCommerceLogo,
    title: "E-Commerce",
    description:
      "Build mobile-first, secure e-commerce platforms with user-focused features. Optimize for SERPs, reach customers easily, and scale.",
  },
  {
    icon: WebDevWebAppLogo,
    title: "Web Applications",
    description:
      "Progressive web apps for mobile-like experiences. Compatible, interactive products that keep dwell metrics above par across devices.",
  },
  {
    icon: WebDevContentLogo,
    title: "Content Management System",
    description:
      "Custom, headless CMS for automated content staging and accelerated time-to-market using intuitive workflows and personalized templates.",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Custom Web Development Services to Broaden{" "}
              <span>Business Prospects</span>
            </h2>
            <p>
              Experience web development prowess with a team specialized in
              agile project management and delivery. Here are the top web
              development solutions, businesses trust TekRevol for.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-4"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Project Scope
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
